module.exports = __webpack_public_path__ + "static/media/logo-landscape.9e34f80b.svg";